export function getTextColor(color: string, textColorLightMode = 'black', textColorDarkMode = 'white'): string {
  return lightOrDark(color) === 'light' ? textColorLightMode : textColorDarkMode;
}

export function lightOrDark(value: string) {
  let r: any, g: any, b: any;
  try {
    if (value.match(/^rgb/)) {
      const color = value.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/) as Array<any>;
      r = color[1];
      g = color[2];
      b = color[3];
    } else {
      let color: any = value;
      color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
      r = color >> 16;
      g = color >> 8 & 255;
      b = color & 255;
    }
  } catch (error) {
    r = 255;
    g = 255;
    b = 255;
  } finally {
    const hsp = Math.sqrt(
      0.299 * (r * r) +
      0.587 * (g * g) +
      0.114 * (b * b)
    );

    return hsp > 165 ? 'light' : 'dark';
  }
}

export function getRootElement(): any {
  return document.querySelector('rb-pravaler')?.shadowRoot || document.querySelector('pravaler-component') || document;
};

export function delay(timeInMilliseconds: number) {
  return new Promise(resolve => setTimeout(resolve, timeInMilliseconds));
}
